import { atom } from 'recoil';
import { PatientRepository } from '~/domain/repository/patientRepository';

export const patientRepositoryState = atom<PatientRepository>({
    key: 'patientRepositoryState',
    default: new PatientRepository(),
    dangerouslyAllowMutability: true,
});

export const selectedPatientIdState = atom<string | null>({
    key: 'selectedPatientIdState',
    default: null,
});

/**
 * Tracks whether the currently loaded patient data has unsaved modifications.
 * Set to true when structure sets, ROIs, or contours are modified.
 * Reset to false after a successful export or when patient data is unloaded.
 */
export const hasUnsavedChangesState = atom<boolean>({
    key: 'hasUnsavedChangesState',
    default: false,
});
